<template>
    <!-- Auth redesign — модалка успеха/ошибки (макет Claude Design «Server Error»).
         Классы am-* (не .modal-*) — иначе конфликт с глобальным bootstrap.css (.modal{display:none}). -->
    <div class="am-modal" role="alertdialog" aria-modal="true">
        <button type="button" class="am-close" aria-label="Close" v-on:click="this.close">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6l12 12M18 6 6 18"/></svg>
        </button>

        <div class="am-icon" :class="{ ok: this.isOk }">
            <svg v-if="this.isOk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7"/></svg>
            <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v6M12 16.5v.01"/></svg>
        </div>

        <h2 class="am-title">{{ this.title }}</h2>
        <div class="am-body" v-html="this.content"></div>

        <div v-if="this.code" class="am-code"><span class="am-dot"></span>{{ this.code }}</div>

        <div class="am-actions">
            <Button name="OK" type="btn-warning" :style="'width: 100%'" v-on:click="this.close" />
        </div>
    </div>
</template>

<script>
import Button from '@/components/service/Button';

export default {
    components: { Button },
    props: {
        close: [Function],
    },
    data() {
        const c = this.$store.state.modal.content || {};
        const ok = c.result === '0' || c.result === 0;
        return {
            isOk: ok,
            title: ok ? this.$t('components.service.modal.Answer.1') : this.$t('components.service.modal.Answer.2'),
            content: c.result_text,
            // тег-код показываем только если бэк его прислал (напр. DKCP_UNAVAILABLE · 503); иначе код идёт инлайн в поля
            code: c.code || false,
        };
    },
};
</script>

<style lang="scss" scoped>
.am-modal {
    position: relative; width: min(420px, 100%); background: var(--card); border-radius: 18px;
    padding: 36px 32px 28px; text-align: center;
    box-shadow: 0 40px 90px -30px rgba(16, 18, 38, .55), 0 4px 14px rgba(16, 18, 38, .12);
}
.am-close {
    position: absolute; top: 16px; right: 16px; width: 34px; height: 34px; border: none; background: none;
    border-radius: 9px; color: var(--ink-faint); cursor: pointer; display: grid; place-items: center;
    transition: background .12s ease, color .12s ease;
}
.am-close:hover { background: #f3f3f6; color: var(--ink); }
.am-close svg { width: 18px; height: 18px; }

.am-icon {
    width: 64px; height: 64px; border-radius: 18px; display: grid; place-items: center; margin: 4px auto 20px;
    background: color-mix(in srgb, var(--danger) 12%, #fff); color: var(--danger);
}
.am-icon.ok { background: color-mix(in srgb, var(--ok) 12%, #fff); color: var(--ok); }
.am-icon svg { width: 32px; height: 32px; }

.am-title { font-family: 'HelveticaNeue bold', 'Roboto bold', sans-serif; font-size: 21px; font-weight: 700; letter-spacing: -0.02em; margin: 0 0 9px; color: var(--ink); }
.am-body { font-size: 14.5px; line-height: 1.55; color: var(--ink-soft); margin: 0 auto; max-width: 32ch; }
.am-body :deep(a) { color: var(--accent-link); font-weight: 600; }
.am-body :deep(p) { margin: 0 0 4px; }

.am-code {
    display: inline-flex; align-items: center; gap: 7px; margin-top: 16px; padding: 5px 11px;
    border-radius: 8px; background: #f4f5f8; border: 1px solid var(--line);
    font-size: 12px; color: var(--ink-soft); font-family: ui-monospace, "SF Mono", Menlo, monospace;
}
.am-code .am-dot { width: 6px; height: 6px; border-radius: 50%; background: var(--danger); flex: none; }

.am-actions { display: flex; flex-direction: column; gap: 10px; margin-top: 24px; }
</style>
